export default __webpack_public_path__ + "static/media/nftmarket.d6736860.png";